<template>
  <!-- Page Content -->
  <div class="hero-static">
    <div class="content">
      <b-row class="justify-content-center">
        <b-col md="8" lg="6" xl="4">
          <!-- Sign In Block -->
          <base-block
            rounded
            themed
            header-class="bg-primary-dark"
            class="mb-0"
            title="Sign In"
          >
            <div class="p-sm-3 px-lg-4 py-lg-4">
              <h1
                class="h2 mb-1 text-capitalize"
                v-if="$route.params.collegeName == 'ngp-arts-commerce-stream'"
              >
                NGP Arts - Commerce & computer science Stream
              </h1>
              <h1 class="h2 mb-1 text-capitalize" v-else>
                {{ $route.params.collegeName.split("-").join(" ") }}
              </h1>
              <!-- Sign In Form -->
              <b-form @submit.stop.prevent="onSubmit">
                <div class="py-3">
                  <div class="form-group">
                    <b-form-input
                      size="lg"
                      class="form-control-alt"
                      id="username"
                      name="username"
                      autocomplete="off"
                      placeholder="Username"
                      v-model="form.username"
                    ></b-form-input>
                  </div>
                  <div class="form-group">
                    <b-form-input
                      type="password"
                      size="lg"
                      class="form-control-alt"
                      id="password"
                      name="password"
                      autocomplete="off"
                      placeholder="Password"
                      v-model="form.password"
                    ></b-form-input>
                  </div>
                  <div></div>
                  <div style="color: red" v-if="loginErrors">
                    {{ loginErrors }}
                  </div>
                </div>
                <b-row class="form-group">
                  <b-col md="6" xl="5">
                    <b-button type="submit" variant="alt-primary" block>
                      <i class="fa fa-fw fa-sign-in-alt mr-1"></i> Sign In
                    </b-button>
                  </b-col>
                </b-row>
              </b-form>
              <!-- END Sign In Form -->
            </div>
          </base-block>
          <!-- END Sign In Block -->
        </b-col>
      </b-row>
    </div>
    <div class="content content-full font-size-sm text-muted text-center">
      <strong>{{ $store.getters.appName }}</strong> &copy;
      {{ $store.getters.appCopyright }}
    </div>
  </div>
  <!-- END Page Content -->
</template>

<script>
export default {
  data() {
    return {
      form: {
        username: "",
        password: "",
      },
    };
  },

  mounted() {
    localStorage.setItem("collegeUrl", this.$route.params.collegeName);
    localStorage.setItem("collegeCollegeId", this.$route.params.collegeId);
  },

  computed: {
    loginErrors() {
      return this.$store.getters.collegeLoginErrors;
    },
  },
  methods: {
    onSubmit() {
      let username = this.form.username;
      let password = this.form.password;
      let url = this.$route.params.collegeName;
      let college_id = this.$route.params.collegeId;
      this.$store.dispatch("collegeLogin", {
        username,
        password,
        url,
        college_id,
      });
    },
  },
};
</script>
